/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowskip2Inputs */

const en_aiflowskip2 = /** @type {(inputs: Aiflowskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip`)
};

const de_aiflowskip2 = /** @type {(inputs: Aiflowskip2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überspringen`)
};

/**
* | output |
* | --- |
* | "Skip" |
*
* @param {Aiflowskip2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowskip2 = /** @type {((inputs?: Aiflowskip2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowskip2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowskip2(inputs)
	return de_aiflowskip2(inputs)
});
export { aiflowskip2 as "aiFlowSkip" }